(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[337],{

/***/ 58530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salary-compass",
      function () {
        return __webpack_require__(12075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ StyledFaqsHeader; },
/* harmony export */   "Ie": function() { return /* binding */ StyledWebFaqs; },
/* harmony export */   "s5": function() { return /* binding */ StyledFaqsSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99655);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: auto;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledFaqsSection = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledFaqsHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73f69e31-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("lg"), components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Heading2 */ .XJ, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"));
var StyledWebFaqs = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dl.withConfig */ .ZP.dl.withConfig({
    componentId: "sc-73f69e31-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_200"));


/***/ }),

/***/ 29372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53307);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99655);
/* harmony import */ var _Faqs_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12109);




var Faqs = function(param) {
    var faqs = param.faqs, title = param.title, desc = param.desc, h3 = param.h3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs && faqs.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsSection */ .s5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFaqsHeader */ .$t, {
                    children: [
                        !h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                            editorial: true,
                            children: title
                        }),
                        h3 && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                            editorial: true,
                            children: title
                        }),
                        desc && typeof desc === "object" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: desc
                        }),
                        typeof desc === "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: desc || ""
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Faqs_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledWebFaqs */ .Ie, {
                    children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_marketingSite_shared_FaqsItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            renderComponent: faq.renderComponent,
                            question: faq.question,
                            answer: faq.answer,
                            anchor: faq.anchor,
                            active: faq.active
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Faqs);


/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable, _extraMeta = param.extraMeta, extraMeta = _extraMeta === void 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : _extraMeta;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl || "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }),
                    extraMeta
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 12075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ salary_compass; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ./components/marketingSite/shared/Faqs.tsx
var Faqs = __webpack_require__(29372);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/salaryCompass/CompassComponent.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledFaqsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5ec61da-0"
})(_templateObject(), (0,theme/* color */.$_)("white"));

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/salaryCompass/sections/features/CompassFeatures.styled.tsx

function CompassFeatures_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: left bottom;\n"
    ]);
    CompassFeatures_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: ",
        " ",
        " ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  display: grid;\n  gap: ",
        ";\n  grid-template-columns: minmax(0, 1fr);\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  padding: ",
        ";\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n\n  img {\n    display: block;\n    height: 5rem;\n  }\n\n  h3 {\n    margin: 0;\n    font-size: ",
        ";\n    font-weight: ",
        ";\n\n    &::before {\n      content: '';\n      display: block;\n      width: ",
        ";\n      height: ",
        ";\n      background-color: ",
        ";\n      margin-bottom: ",
        ";\n    }\n  }\n\n  p {\n    margin: 0;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1f51942-0"
})(CompassFeatures_styled_templateObject(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/salaryCompass/compass.svg"), "')");
});
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1f51942-1"
})(_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl6"));
var StyledFeatures = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1f51942-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledFeature = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1f51942-3"
})(_templateObject3(), (0,theme/* color */.$_)("white"), (0,theme/* radius */.q0)("lg"), (0,theme/* shadow */.AF)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("emerald_600"), (0,theme/* spacing */.W0)("sm"));

;// CONCATENATED MODULE: ./components/marketingSite/salaryCompass/sections/features/CompassFeatures.tsx











var CompassFeatures = function() {
    var t = (0,useI18n/* useI18n */.Q)("salary-compass").t;
    var locale = (0,router.useRouter)().locale;
    var features = [
        {
            title: t("salary-compass.features.market-info.title"),
            desc: t("salary-compass.features.market-info.desc"),
            image: (0,paths/* getPublicPath */.A)("/images/salaryCompass/market-info.svg")
        },
        {
            title: t("salary-compass.features.reliability.title"),
            desc: t("salary-compass.features.reliability.desc"),
            image: (0,paths/* getPublicPath */.A)("/images/salaryCompass/reliability.svg")
        },
        {
            title: t("salary-compass.features.data.title"),
            desc: t("salary-compass.features.data.desc"),
            image: (0,paths/* getPublicPath */.A)("/images/salaryCompass/data.svg")
        },
        {
            title: t("salary-compass.features.simulation.title"),
            desc: t("salary-compass.features.simulation.desc"),
            image: (0,paths/* getPublicPath */.A)("/images/salaryCompass/simulation.svg")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                    as: "h2",
                    editorial: true,
                    children: t("salary-compass.features.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeatures, {
                    children: features.map(function(feature, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeature, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: feature.image,
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: feature.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: feature.desc
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.salaryBenchmark */.uu.salaryBenchmark, locale)),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                        variant: "brandTalent",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("salary-compass.features.cta")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faCompass */.GTN
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var features_CompassFeatures = (CompassFeatures);

;// CONCATENATED MODULE: ./components/marketingSite/salaryCompass/sections/hero/CompassHero.styled.tsx

function CompassHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: left 15% bottom;\n  background-size: cover;\n  padding: 0 ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding: ",
        " ",
        " ",
        ";\n    background-size: cover;\n    background-position: center bottom;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    CompassHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompassHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  z-index: 1;\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    CompassHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompassHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  color: ",
        ";\n  line-height: 1.5;\n  text-align: center;\n  margin: auto;\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n    font-size: ",
        ";\n    line-height: 1.4;\n    margin: unset;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    CompassHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompassHero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    CompassHero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  img {\n    display: block;\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c233c7b-0"
})(CompassHero_styled_templateObject(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/salaryCompass/bg-hero.svg"), "')");
}, (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c233c7b-1"
})(CompassHero_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"));
var StyledHeroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c233c7b-2"
})(CompassHero_styled_templateObject2(), (0,theme/* container */.nC)("xs"), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"));
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-7c233c7b-3"
})(CompassHero_styled_templateObject3(), (0,theme/* spacing */.W0)("lg"));
var StyledHeroImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7c233c7b-4"
})(_templateObject4(), (0,theme/* radius */.q0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* radius */.q0)("lg"), (0,theme/* radius */.q0)("lg"), (0,theme/* shadow */.AF)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/salaryCompass/sections/hero/CompassHero.tsx











var CompassHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("salary-compass").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHero, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroText, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroTitle, {
                            children: t("salary-compass.hero.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            dangerouslySetInnerHTML: {
                                __html: t("salary-compass.hero.desc")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale={locale}&source=unete-hero-brujula&returnUrl=").concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.salaryBenchmark */.uu.salaryBenchmark, locale)),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                variant: "brandTalent",
                                onClick: function(e) {
                                    return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=unete-hero-brujula"), "unete-hero-brujula");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("salary-compass.hero.cta")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_light_svg_icons/* faArrowRight */.eFW
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/salaryCompass/salary-benchmark.png"),
                        alt: ""
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_CompassHero = (CompassHero);

;// CONCATENATED MODULE: ./components/marketingSite/salaryCompass/CompassComponent.tsx











var CompassComponent = function() {
    var t = (0,useI18n/* useI18n */.Q)("salary-compass").t;
    var locale = (0,router.useRouter)().locale;
    var faqs = [
        {
            question: t("salary-compass.faqs.faq1.question"),
            active: true,
            answer: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "salary-compass",
                i18nKey: "salary-compass.faqs.faq1.answer",
                components: {
                    portalAccess: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.portalV2Dashboard */.uu.portalV2Dashboard, locale))
                    }),
                    portalCreate: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=unete-brujula"),
                        onClick: function(e) {
                            return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=unete-brujula"), "unete-brujula");
                        }
                    })
                }
            }),
            renderComponent: true
        },
        {
            question: t("salary-compass.faqs.faq2.question"),
            answer: t("salary-compass.faqs.faq2.answer")
        },
        {
            question: t("salary-compass.faqs.faq3.question"),
            answer: t("salary-compass.faqs.faq3.answer")
        },
        {
            question: t("salary-compass.faqs.faq4.question"),
            answer: t("salary-compass.faqs.faq4.answer")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_CompassHero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(features_CompassFeatures, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFaqsWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                        faqs: faqs,
                        title: t("salary-compass.faqs.title")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var salaryCompass_CompassComponent = (CompassComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/salary-compass.tsx







var SalaryCompassPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("salary-compass").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("salary-compass.page_title"),
                url: app_urls/* APP_URLS.salaryCompass */.uu.salaryCompass,
                desc: t("salary-compass.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_salary_compass.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(salaryCompass_CompassComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var salary_compass = (SalaryCompassPage);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,7265,9774,2888,179], function() { return __webpack_exec__(58530); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);